import { useEffect, useState } from 'react';
import { useCustomizationParams } from '../../context/ViewerContext';
import { ViewerAttributeInputInterface, ViewerGroupInputItemsInterface } from '../../core';

export const useBulkLimit = (bulkData: ViewerGroupInputItemsInterface | null) => {
  const [disableCart, setDisableCart] = useState<boolean | undefined>(undefined);
  const { customizationParams } = useCustomizationParams();

  const getOptionsValues = (attrs: ViewerAttributeInputInterface[]) => {
    const valueSums = attrs.map((attr) => {
      const sum = attr.options.reduce((acc, opt) => {
        return acc + opt.value;
      }, 0);

      return {
        id: attr.id,
        sum,
      };
    });

    return valueSums;
  };

  useEffect(() => {
    const urlParamsGet = new URLSearchParams(window.location.search);
    const customizationComposition = urlParamsGet.get('composition');

    if (!customizationParams) return;
    if (!customizationParams.bulkLimitConfig) return;

    const { attributes } = bulkData || {};
    if (!attributes) return;
    const valueSum = getOptionsValues(attributes);
    const config = !!customizationComposition ? customizationParams.bulkLimitConfigComposition : customizationParams.bulkLimitConfig;
    if (!config) return;
    const bulkConfig = config
      .map((config) => {
        const { category, minimum } = config;
        const categorySum = valueSum.filter((sum) => category.includes(sum.id));
        const sum = categorySum.reduce((acc, sum) => {
          return acc + sum.sum;
        }, 0);

        return {
          sum,
          minimum,
        };
      })
      .filter((config) => config.sum !== 0);

    if (bulkConfig.length === 0) return setDisableCart(true);

    // check if sum is less than limit in all categories
    const check = bulkConfig.every((config) => {
      return config.sum >= config.minimum;
    });

    setDisableCart(!check);
  }, [bulkData, customizationParams]);

  return { disableCart };
};

export default useBulkLimit;
